export class AppIcons {
  'icon-account_circle': string;
  'icon-add-circle': string;
  'icon-add-image': string;
  'icon-add-note': string;
  'icon-add': string;
  'icon-allow_login_access_black': string;
  'icon-archive': string;
  'icon-arrow-back-1': string;
  'icon-arrow-back': string;
  'icon-arrow-down-up': string;
  'icon-arrow-down': string;
  'icon-arrow-drop-down': string;
  'icon-arrow-drop-up': string;
  'icon-arrow-forward-1': string;
  'icon-arrow-forward': string;
  'icon-arrow-left': string;
  'icon-arrow-right': string;
  'icon-arrow-up': string;
  'icon-arrow': string;
  'icon-arrow_fill': string;
  'icon-at-sign': string;
  'icon-attach': string;
  'icon-automation': string;
  'icon-bar_chart': string;
  'icon-barcode-scan': string;
  'icon-battery-tracker': string;
  'icon-battery_alert': string;
  'icon-bookmark-bold': string;
  'icon-bookmark': string;
  'icon-brick': string;
  'icon-business-center-bold': string;
  'icon-business': string;
  'icon-cabin_view': string;
  'icon-cabin_view_filled': string;
  'icon-calendar_month': string;
  'icon-call': string;
  'icon-camera-1-way': string;
  'icon-camera-2-way': string;
  'icon-camera-3-way': string;
  'icon-camera-4-way': string;
  'icon-camera-plus': string;
  'icon-cancel': string;
  'icon-chat_bubble_outline': string;
  'icon-chats-bold': string;
  'icon-chats-outline': string;
  'icon-check-circle-bold': string;
  'icon-check-circle': string;
  'icon-clipboard-tick-bold': string;
  'icon-clipboard': string;
  'icon-clock-bold': string;
  'icon-clock': string;
  'icon-close': string;
  'icon-cloud-upload': string;
  'icon-collections': string;
  'icon-compact-view': string;
  'icon-contact_phone': string;
  'icon-content-plus': string;
  'icon-copy-link': string;
  'icon-copy': string;
  'icon-crm-bold': string;
  'icon-crm-outline': string;
  'icon-crm_admin_assign': string;
  'icon-crm_admin_unassign': string;
  'icon-date_range': string;
  'icon-delete': string;
  'icon-direct-message': string;
  'icon-directions': string;
  'icon-document-bold': string;
  'icon-document-outline': string;
  'icon-download': string;
  'icon-drag-indicator': string;
  'icon-draw-boundary': string;
  'icon-draw-circle': string;
  'icon-draw-polygon': string;
  'icon-drop': string;
  'icon-dvr-camera': string;
  'icon-edit': string;
  'icon-emoji': string;
  'icon-empty_state_alert': string;
  'icon-empty_state_clock-stopwatch': string;
  'icon-empty_state_documents': string;
  'icon-empty_state_employee_group': string;
  'icon-empty_state_event': string;
  'icon-empty_state_history': string;
  'icon-empty_state_media': string;
  'icon-empty_state_message-chat': string;
  'icon-empty_state_mobile-x': string;
  'icon-empty_state_no_access': string;
  'icon-empty_state_vehicle': string;
  'icon-engine-bold': string;
  'icon-engine-hours': string;
  'icon-engine': string;
  'icon-enter': string;
  'icon-entered': string;
  'icon-error': string;
  'icon-ev-station-bold': string;
  'icon-events-bold': string;
  'icon-events-outline': string;
  'icon-fiber_pin': string;
  'icon-file': string;
  'icon-filter': string;
  'icon-first-page': string;
  'icon-flag-bold': string;
  'icon-flag': string;
  'icon-flame-bold': string;
  'icon-flash-bold': string;
  'icon-folder': string;
  'icon-format-bold': string;
  'icon-format-clear': string;
  'icon-format-italic': string;
  'icon-format-underlined': string;
  'icon-gas-station-bold': string;
  'icon-gps-slash': string;
  'icon-grain': string;
  'icon-grid-2': string;
  'icon-grid-3': string;
  'icon-grid-4': string;
  'icon-grid': string;
  'icon-group-bold': string;
  'icon-group-outline': string;
  'icon-hardware': string;
  'icon-hardwired-tracker': string;
  'icon-hashtag': string;
  'icon-heart-bold': string;
  'icon-help-bold': string;
  'icon-help-outline': string;
  'icon-highlight_off': string;
  'icon-home-bold': string;
  'icon-home-outline': string;
  'icon-hotel-bold': string;
  'icon-image-slash': string;
  'icon-image': string;
  'icon-in-progress-status': string;
  'icon-inbox': string;
  'icon-info-circle': string;
  'icon-info_filled': string;
  'icon-inspections-bold': string;
  'icon-inspections-outline': string;
  'icon-inventory': string;
  'icon-kanban': string;
  'icon-key': string;
  'icon-lamp': string;
  'icon-landscape-bold': string;
  'icon-landslide': string;
  'icon-last-page': string;
  'icon-layers': string;
  'icon-leaf': string;
  'icon-link': string;
  'icon-list-bulleted': string;
  'icon-list-numbered': string;
  'icon-load': string;
  'icon-local_shipping': string;
  'icon-location-bold': string;
  'icon-location-outline': string;
  'icon-lock': string;
  'icon-login': string;
  'icon-logout': string;
  'icon-mail': string;
  'icon-mail_outline': string;
  'icon-main-image': string;
  'icon-map-bold': string;
  'icon-map-outline': string;
  'icon-marker-arrow': string;
  'icon-max-hours': string;
  'icon-maximize': string;
  'icon-mdi_clock-remove-outline': string;
  'icon-menu': string;
  'icon-microphone': string;
  'icon-miles': string;
  'icon-min-hours': string;
  'icon-minimize': string;
  'icon-minus-circle-bold': string;
  'icon-moneys': string;
  'icon-monitor-mobile': string;
  'icon-more': string;
  'icon-my-location': string;
  'icon-new-window': string;
  'icon-news-bold': string;
  'icon-news-outline': string;
  'icon-no-date': string;
  'icon-none-qr': string;
  'icon-notes': string;
  'icon-notification-bold': string;
  'icon-notification-outline': string;
  'icon-notifications-off': string;
  'icon-operator-off': string;
  'icon-operator-on': string;
  'icon-operator': string;
  'icon-operator_off': string;
  'icon-operator_on': string;
  'icon-pan-tool': string;
  'icon-parking-bold': string;
  'icon-pause-bold': string;
  'icon-pause': string;
  'icon-perimeter': string;
  'icon-person': string;
  'icon-pick-up': string;
  'icon-picture-in-picture': string;
  'icon-pin': string;
  'icon-play-bold': string;
  'icon-play': string;
  'icon-poll': string;
  'icon-power': string;
  'icon-profile-circle': string;
  'icon-project': string;
  'icon-public': string;
  'icon-qr-scan': string;
  'icon-radio-button-off': string;
  'icon-radio-button-on': string;
  'icon-record-stop': string;
  'icon-record': string;
  'icon-recycling': string;
  'icon-redo': string;
  'icon-refresh': string;
  'icon-reload': string;
  'icon-remove': string;
  'icon-reply': string;
  'icon-reports-bold': string;
  'icon-reports-outline': string;
  'icon-restaurant-bold': string;
  'icon-restore': string;
  'icon-road': string;
  'icon-route': string;
  'icon-route_map': string;
  'icon-save': string;
  'icon-scroll': string;
  'icon-search-bold': string;
  'icon-search-outline': string;
  'icon-search-zoom-in': string;
  'icon-search-zoom-out': string;
  'icon-send-bold': string;
  'icon-settings-bold': string;
  'icon-settings-outline': string;
  'icon-share': string;
  'icon-shield-tick-bold': string;
  'icon-sidebar-left-outline': string;
  'icon-sidebar-right-outline': string;
  'icon-signal': string;
  'icon-simple': string;
  'icon-slash': string;
  'icon-solar-tracker': string;
  'icon-sort': string;
  'icon-speed': string;
  'icon-star-bold': string;
  'icon-star': string;
  'icon-status-idling-bold': string;
  'icon-status-stopped-bold': string;
  'icon-status-towed-bold': string;
  'icon-status-traveling-bold': string;
  'icon-status': string;
  'icon-subdirectory-arrow': string;
  'icon-swap-bold': string;
  'icon-swap-calls': string;
  'icon-swap-outline': string;
  'icon-table': string;
  'icon-tablet': string;
  'icon-tasks-bold': string;
  'icon-tasks-outline': string;
  'icon-text-format': string;
  'icon-texture': string;
  'icon-tick': string;
  'icon-today': string;
  'icon-tool-bold': string;
  'icon-tool': string;
  'icon-tree': string;
  'icon-unarchive': string;
  'icon-undo': string;
  'icon-unlink': string;
  'icon-unpin': string;
  'icon-upload': string;
  'icon-user-group': string;
  'icon-user-remove': string;
  'icon-user-tick': string;
  'icon-user': string;
  'icon-vehicles-bold': string;
  'icon-vehicles-group': string;
  'icon-vehicles-outline': string;
  'icon-video-request': string;
  'icon-videocam': string;
  'icon-visibility-off': string;
  'icon-visibility': string;
  'icon-volume-off': string;
  'icon-volume-up': string;
  'icon-warning-bold': string;
  'icon-warning': string;
  'icon-water': string;
  'icon-wheel': string;
  'icon-wifi': string;
  'icon-wifi_off': string;
  'icon-working-yard-bold': string;
  'icon-wrench-bold': string;
  'icon-zoom-out': string;
}

export type AppIconsType = keyof AppIcons;

export const iconsList: AppIcons = {
  'icon-account_circle': 'assets/core-icons/account_circle.svg',
  'icon-add-circle': 'assets/core-icons/add-circle.svg',
  'icon-add-image': 'assets/core-icons/add-image.svg',
  'icon-add-note': 'assets/core-icons/add-note.svg',
  'icon-add': 'assets/core-icons/add.svg',
  'icon-allow_login_access_black':
    'assets/core-icons/allow_login_access_black.svg',
  'icon-archive': 'assets/core-icons/archive.svg',
  'icon-arrow-back-1': 'assets/core-icons/arrow-back-1.svg',
  'icon-arrow-back': 'assets/core-icons/arrow-back.svg',
  'icon-arrow-down-up': 'assets/core-icons/arrow-down-up.svg',
  'icon-arrow-down': 'assets/core-icons/arrow-down.svg',
  'icon-arrow-drop-down': 'assets/core-icons/arrow-drop-down.svg',
  'icon-arrow-drop-up': 'assets/core-icons/arrow-drop-up.svg',
  'icon-arrow-forward-1': 'assets/core-icons/arrow-forward-1.svg',
  'icon-arrow-forward': 'assets/core-icons/arrow-forward.svg',
  'icon-arrow-left': 'assets/core-icons/arrow-left.svg',
  'icon-arrow-right': 'assets/core-icons/arrow-right.svg',
  'icon-arrow-up': 'assets/core-icons/arrow-up.svg',
  'icon-arrow': 'assets/core-icons/arrow.svg',
  'icon-arrow_fill': 'assets/core-icons/arrow_fill.svg',
  'icon-at-sign': 'assets/core-icons/at-sign.svg',
  'icon-attach': 'assets/core-icons/attach.svg',
  'icon-automation': 'assets/core-icons/automation.svg',
  'icon-bar_chart': 'assets/core-icons/bar_chart.svg',
  'icon-barcode-scan': 'assets/core-icons/barcode-scan.svg',
  'icon-battery-tracker': 'assets/core-icons/battery-tracker.svg',
  'icon-battery_alert': 'assets/core-icons/battery_alert.svg',
  'icon-bookmark-bold': 'assets/core-icons/bookmark-bold.svg',
  'icon-bookmark': 'assets/core-icons/bookmark.svg',
  'icon-brick': 'assets/core-icons/brick.svg',
  'icon-business-center-bold': 'assets/core-icons/business-center-bold.svg',
  'icon-business': 'assets/core-icons/business.svg',
  'icon-cabin_view': 'assets/core-icons/cabin_view.svg',
  'icon-cabin_view_filled': 'assets/core-icons/cabin_view_filled.svg',
  'icon-calendar_month': 'assets/core-icons/calendar_month.svg',
  'icon-call': 'assets/core-icons/call.svg',
  'icon-camera-1-way': 'assets/core-icons/camera-1-way.svg',
  'icon-camera-2-way': 'assets/core-icons/camera-2-way.svg',
  'icon-camera-3-way': 'assets/core-icons/camera-3-way.svg',
  'icon-camera-4-way': 'assets/core-icons/camera-4-way.svg',
  'icon-camera-plus': 'assets/core-icons/camera-plus.svg',
  'icon-cancel': 'assets/core-icons/cancel.svg',
  'icon-chat_bubble_outline': 'assets/core-icons/chat_bubble_outline.svg',
  'icon-chats-bold': 'assets/core-icons/chats-bold.svg',
  'icon-chats-outline': 'assets/core-icons/chats-outline.svg',
  'icon-check-circle-bold': 'assets/core-icons/check-circle-bold.svg',
  'icon-check-circle': 'assets/core-icons/check-circle.svg',
  'icon-clipboard-tick-bold': 'assets/core-icons/clipboard-tick-bold.svg',
  'icon-clipboard': 'assets/core-icons/clipboard.svg',
  'icon-clock-bold': 'assets/core-icons/clock-bold.svg',
  'icon-clock': 'assets/core-icons/clock.svg',
  'icon-close': 'assets/core-icons/close.svg',
  'icon-cloud-upload': 'assets/core-icons/cloud-upload.svg',
  'icon-collections': 'assets/core-icons/collections.svg',
  'icon-compact-view': 'assets/core-icons/compact-view.svg',
  'icon-contact_phone': 'assets/core-icons/contact_phone.svg',
  'icon-content-plus': 'assets/core-icons/content-plus.svg',
  'icon-copy-link': 'assets/core-icons/copy-link.svg',
  'icon-copy': 'assets/core-icons/copy.svg',
  'icon-crm-bold': 'assets/core-icons/crm-bold.svg',
  'icon-crm-outline': 'assets/core-icons/crm-outline.svg',
  'icon-crm_admin_assign': 'assets/core-icons/crm_admin_assign.svg',
  'icon-crm_admin_unassign': 'assets/core-icons/crm_admin_unassign.svg',
  'icon-date_range': 'assets/core-icons/date_range.svg',
  'icon-delete': 'assets/core-icons/delete.svg',
  'icon-direct-message': 'assets/core-icons/direct-message.svg',
  'icon-directions': 'assets/core-icons/directions.svg',
  'icon-document-bold': 'assets/core-icons/document-bold.svg',
  'icon-document-outline': 'assets/core-icons/document-outline.svg',
  'icon-download': 'assets/core-icons/download.svg',
  'icon-drag-indicator': 'assets/core-icons/drag-indicator.svg',
  'icon-draw-boundary': 'assets/core-icons/draw-boundary.svg',
  'icon-draw-circle': 'assets/core-icons/draw-circle.svg',
  'icon-draw-polygon': 'assets/core-icons/draw-polygon.svg',
  'icon-drop': 'assets/core-icons/drop.svg',
  'icon-dvr-camera': 'assets/core-icons/dvr-camera.svg',
  'icon-edit': 'assets/core-icons/edit.svg',
  'icon-emoji': 'assets/core-icons/emoji.svg',
  'icon-empty_state_alert': 'assets/core-icons/empty_state_alert.svg',
  'icon-empty_state_clock-stopwatch':
    'assets/core-icons/empty_state_clock-stopwatch.svg',
  'icon-empty_state_documents': 'assets/core-icons/empty_state_documents.svg',
  'icon-empty_state_employee_group':
    'assets/core-icons/empty_state_employee_group.svg',
  'icon-empty_state_event': 'assets/core-icons/empty_state_event.svg',
  'icon-empty_state_history': 'assets/core-icons/empty_state_history.svg',
  'icon-empty_state_media': 'assets/core-icons/empty_state_media.svg',
  'icon-empty_state_message-chat':
    'assets/core-icons/empty_state_message-chat.svg',
  'icon-empty_state_mobile-x': 'assets/core-icons/empty_state_mobile-x.svg',
  'icon-empty_state_no_access': 'assets/core-icons/empty_state_no_access.svg',
  'icon-empty_state_vehicle': 'assets/core-icons/empty_state_vehicle.svg',
  'icon-engine-bold': 'assets/core-icons/engine-bold.svg',
  'icon-engine-hours': 'assets/core-icons/engine-hours.svg',
  'icon-engine': 'assets/core-icons/engine.svg',
  'icon-enter': 'assets/core-icons/enter.svg',
  'icon-entered': 'assets/core-icons/entered.svg',
  'icon-error': 'assets/core-icons/error.svg',
  'icon-ev-station-bold': 'assets/core-icons/ev-station-bold.svg',
  'icon-events-bold': 'assets/core-icons/events-bold.svg',
  'icon-events-outline': 'assets/core-icons/events-outline.svg',
  'icon-fiber_pin': 'assets/core-icons/fiber_pin.svg',
  'icon-file': 'assets/core-icons/file.svg',
  'icon-filter': 'assets/core-icons/filter.svg',
  'icon-first-page': 'assets/core-icons/first-page.svg',
  'icon-flag-bold': 'assets/core-icons/flag-bold.svg',
  'icon-flag': 'assets/core-icons/flag.svg',
  'icon-flame-bold': 'assets/core-icons/flame-bold.svg',
  'icon-flash-bold': 'assets/core-icons/flash-bold.svg',
  'icon-folder': 'assets/core-icons/folder.svg',
  'icon-format-bold': 'assets/core-icons/format-bold.svg',
  'icon-format-clear': 'assets/core-icons/format-clear.svg',
  'icon-format-italic': 'assets/core-icons/format-italic.svg',
  'icon-format-underlined': 'assets/core-icons/format-underlined.svg',
  'icon-gas-station-bold': 'assets/core-icons/gas-station-bold.svg',
  'icon-gps-slash': 'assets/core-icons/gps-slash.svg',
  'icon-grain': 'assets/core-icons/grain.svg',
  'icon-grid-2': 'assets/core-icons/grid-2.svg',
  'icon-grid-3': 'assets/core-icons/grid-3.svg',
  'icon-grid-4': 'assets/core-icons/grid-4.svg',
  'icon-grid': 'assets/core-icons/grid.svg',
  'icon-group-bold': 'assets/core-icons/group-bold.svg',
  'icon-group-outline': 'assets/core-icons/group-outline.svg',
  'icon-hardware': 'assets/core-icons/hardware.svg',
  'icon-hardwired-tracker': 'assets/core-icons/hardwired-tracker.svg',
  'icon-hashtag': 'assets/core-icons/hashtag.svg',
  'icon-heart-bold': 'assets/core-icons/heart-bold.svg',
  'icon-help-bold': 'assets/core-icons/help-bold.svg',
  'icon-help-outline': 'assets/core-icons/help-outline.svg',
  'icon-highlight_off': 'assets/core-icons/highlight_off.svg',
  'icon-home-bold': 'assets/core-icons/home-bold.svg',
  'icon-home-outline': 'assets/core-icons/home-outline.svg',
  'icon-hotel-bold': 'assets/core-icons/hotel-bold.svg',
  'icon-image-slash': 'assets/core-icons/image-slash.svg',
  'icon-image': 'assets/core-icons/image.svg',
  'icon-in-progress-status': 'assets/core-icons/in-progress-status.svg',
  'icon-inbox': 'assets/core-icons/inbox.svg',
  'icon-info-circle': 'assets/core-icons/info-circle.svg',
  'icon-info_filled': 'assets/core-icons/info_filled.svg',
  'icon-inspections-bold': 'assets/core-icons/inspections-bold.svg',
  'icon-inspections-outline': 'assets/core-icons/inspections-outline.svg',
  'icon-inventory': 'assets/core-icons/inventory.svg',
  'icon-kanban': 'assets/core-icons/kanban.svg',
  'icon-key': 'assets/core-icons/key.svg',
  'icon-lamp': 'assets/core-icons/lamp.svg',
  'icon-landscape-bold': 'assets/core-icons/landscape-bold.svg',
  'icon-landslide': 'assets/core-icons/landslide.svg',
  'icon-last-page': 'assets/core-icons/last-page.svg',
  'icon-layers': 'assets/core-icons/layers.svg',
  'icon-leaf': 'assets/core-icons/leaf.svg',
  'icon-link': 'assets/core-icons/link.svg',
  'icon-list-bulleted': 'assets/core-icons/list-bulleted.svg',
  'icon-list-numbered': 'assets/core-icons/list-numbered.svg',
  'icon-load': 'assets/core-icons/load.svg',
  'icon-local_shipping': 'assets/core-icons/local_shipping.svg',
  'icon-location-bold': 'assets/core-icons/location-bold.svg',
  'icon-location-outline': 'assets/core-icons/location-outline.svg',
  'icon-lock': 'assets/core-icons/lock.svg',
  'icon-login': 'assets/core-icons/login.svg',
  'icon-logout': 'assets/core-icons/logout.svg',
  'icon-mail': 'assets/core-icons/mail.svg',
  'icon-mail_outline': 'assets/core-icons/mail_outline.svg',
  'icon-main-image': 'assets/core-icons/main-image.svg',
  'icon-map-bold': 'assets/core-icons/map-bold.svg',
  'icon-map-outline': 'assets/core-icons/map-outline.svg',
  'icon-marker-arrow': 'assets/core-icons/marker-arrow.svg',
  'icon-max-hours': 'assets/core-icons/max-hours.svg',
  'icon-maximize': 'assets/core-icons/maximize.svg',
  'icon-mdi_clock-remove-outline':
    'assets/core-icons/mdi_clock-remove-outline.svg',
  'icon-menu': 'assets/core-icons/menu.svg',
  'icon-microphone': 'assets/core-icons/microphone.svg',
  'icon-miles': 'assets/core-icons/miles.svg',
  'icon-min-hours': 'assets/core-icons/min-hours.svg',
  'icon-minimize': 'assets/core-icons/minimize.svg',
  'icon-minus-circle-bold': 'assets/core-icons/minus-circle-bold.svg',
  'icon-moneys': 'assets/core-icons/moneys.svg',
  'icon-monitor-mobile': 'assets/core-icons/monitor-mobile.svg',
  'icon-more': 'assets/core-icons/more.svg',
  'icon-my-location': 'assets/core-icons/my-location.svg',
  'icon-new-window': 'assets/core-icons/new-window.svg',
  'icon-news-bold': 'assets/core-icons/news-bold.svg',
  'icon-news-outline': 'assets/core-icons/news-outline.svg',
  'icon-no-date': 'assets/core-icons/no-date.svg',
  'icon-none-qr': 'assets/core-icons/none-qr.svg',
  'icon-notes': 'assets/core-icons/notes.svg',
  'icon-notification-bold': 'assets/core-icons/notification-bold.svg',
  'icon-notification-outline': 'assets/core-icons/notification-outline.svg',
  'icon-notifications-off': 'assets/core-icons/notifications-off.svg',
  'icon-operator-off': 'assets/core-icons/operator-off.svg',
  'icon-operator-on': 'assets/core-icons/operator-on.svg',
  'icon-operator': 'assets/core-icons/operator.svg',
  'icon-operator_off': 'assets/core-icons/operator_off.svg',
  'icon-operator_on': 'assets/core-icons/operator_on.svg',
  'icon-pan-tool': 'assets/core-icons/pan-tool.svg',
  'icon-parking-bold': 'assets/core-icons/parking-bold.svg',
  'icon-pause-bold': 'assets/core-icons/pause-bold.svg',
  'icon-pause': 'assets/core-icons/pause.svg',
  'icon-perimeter': 'assets/core-icons/perimeter.svg',
  'icon-person': 'assets/core-icons/person.svg',
  'icon-pick-up': 'assets/core-icons/pick-up.svg',
  'icon-picture-in-picture': 'assets/core-icons/picture-in-picture.svg',
  'icon-pin': 'assets/core-icons/pin.svg',
  'icon-play-bold': 'assets/core-icons/play-bold.svg',
  'icon-play': 'assets/core-icons/play.svg',
  'icon-poll': 'assets/core-icons/poll.svg',
  'icon-power': 'assets/core-icons/power.svg',
  'icon-profile-circle': 'assets/core-icons/profile-circle.svg',
  'icon-project': 'assets/core-icons/project.svg',
  'icon-public': 'assets/core-icons/public.svg',
  'icon-qr-scan': 'assets/core-icons/qr-scan.svg',
  'icon-radio-button-off': 'assets/core-icons/radio-button-off.svg',
  'icon-radio-button-on': 'assets/core-icons/radio-button-on.svg',
  'icon-record-stop': 'assets/core-icons/record-stop.svg',
  'icon-record': 'assets/core-icons/record.svg',
  'icon-recycling': 'assets/core-icons/recycling.svg',
  'icon-redo': 'assets/core-icons/redo.svg',
  'icon-refresh': 'assets/core-icons/refresh.svg',
  'icon-reload': 'assets/core-icons/reload.svg',
  'icon-remove': 'assets/core-icons/remove.svg',
  'icon-reply': 'assets/core-icons/reply.svg',
  'icon-reports-bold': 'assets/core-icons/reports-bold.svg',
  'icon-reports-outline': 'assets/core-icons/reports-outline.svg',
  'icon-restaurant-bold': 'assets/core-icons/restaurant-bold.svg',
  'icon-restore': 'assets/core-icons/restore.svg',
  'icon-road': 'assets/core-icons/road.svg',
  'icon-route': 'assets/core-icons/route.svg',
  'icon-route_map': 'assets/core-icons/route_map.svg',
  'icon-save': 'assets/core-icons/save.svg',
  'icon-scroll': 'assets/core-icons/scroll.svg',
  'icon-search-bold': 'assets/core-icons/search-bold.svg',
  'icon-search-outline': 'assets/core-icons/search-outline.svg',
  'icon-search-zoom-in': 'assets/core-icons/search-zoom-in.svg',
  'icon-search-zoom-out': 'assets/core-icons/search-zoom-out.svg',
  'icon-send-bold': 'assets/core-icons/send-bold.svg',
  'icon-settings-bold': 'assets/core-icons/settings-bold.svg',
  'icon-settings-outline': 'assets/core-icons/settings-outline.svg',
  'icon-share': 'assets/core-icons/share.svg',
  'icon-shield-tick-bold': 'assets/core-icons/shield-tick-bold.svg',
  'icon-sidebar-left-outline': 'assets/core-icons/sidebar-left-outline.svg',
  'icon-sidebar-right-outline': 'assets/core-icons/sidebar-right-outline.svg',
  'icon-signal': 'assets/core-icons/signal.svg',
  'icon-simple': 'assets/core-icons/simple.svg',
  'icon-slash': 'assets/core-icons/slash.svg',
  'icon-solar-tracker': 'assets/core-icons/solar-tracker.svg',
  'icon-sort': 'assets/core-icons/sort.svg',
  'icon-speed': 'assets/core-icons/speed.svg',
  'icon-star-bold': 'assets/core-icons/star-bold.svg',
  'icon-star': 'assets/core-icons/star.svg',
  'icon-status-idling-bold': 'assets/core-icons/status-idling-bold.svg',
  'icon-status-stopped-bold': 'assets/core-icons/status-stopped-bold.svg',
  'icon-status-towed-bold': 'assets/core-icons/status-towed-bold.svg',
  'icon-status-traveling-bold': 'assets/core-icons/status-traveling-bold.svg',
  'icon-status': 'assets/core-icons/status.svg',
  'icon-subdirectory-arrow': 'assets/core-icons/subdirectory-arrow.svg',
  'icon-swap-bold': 'assets/core-icons/swap-bold.svg',
  'icon-swap-calls': 'assets/core-icons/swap-calls.svg',
  'icon-swap-outline': 'assets/core-icons/swap-outline.svg',
  'icon-table': 'assets/core-icons/table.svg',
  'icon-tablet': 'assets/core-icons/tablet.svg',
  'icon-tasks-bold': 'assets/core-icons/tasks-bold.svg',
  'icon-tasks-outline': 'assets/core-icons/tasks-outline.svg',
  'icon-text-format': 'assets/core-icons/text-format.svg',
  'icon-texture': 'assets/core-icons/texture.svg',
  'icon-tick': 'assets/core-icons/tick.svg',
  'icon-today': 'assets/core-icons/today.svg',
  'icon-tool-bold': 'assets/core-icons/tool-bold.svg',
  'icon-tool': 'assets/core-icons/tool.svg',
  'icon-tree': 'assets/core-icons/tree.svg',
  'icon-unarchive': 'assets/core-icons/unarchive.svg',
  'icon-undo': 'assets/core-icons/undo.svg',
  'icon-unlink': 'assets/core-icons/unlink.svg',
  'icon-unpin': 'assets/core-icons/unpin.svg',
  'icon-upload': 'assets/core-icons/upload.svg',
  'icon-user-group': 'assets/core-icons/user-group.svg',
  'icon-user-remove': 'assets/core-icons/user-remove.svg',
  'icon-user-tick': 'assets/core-icons/user-tick.svg',
  'icon-user': 'assets/core-icons/user.svg',
  'icon-vehicles-bold': 'assets/core-icons/vehicles-bold.svg',
  'icon-vehicles-group': 'assets/core-icons/vehicles-group.svg',
  'icon-vehicles-outline': 'assets/core-icons/vehicles-outline.svg',
  'icon-video-request': 'assets/core-icons/video-request.svg',
  'icon-videocam': 'assets/core-icons/videocam.svg',
  'icon-visibility-off': 'assets/core-icons/visibility-off.svg',
  'icon-visibility': 'assets/core-icons/visibility.svg',
  'icon-volume-off': 'assets/core-icons/volume-off.svg',
  'icon-volume-up': 'assets/core-icons/volume-up.svg',
  'icon-warning-bold': 'assets/core-icons/warning-bold.svg',
  'icon-warning': 'assets/core-icons/warning.svg',
  'icon-water': 'assets/core-icons/water.svg',
  'icon-wheel': 'assets/core-icons/wheel.svg',
  'icon-wifi': 'assets/core-icons/wifi.svg',
  'icon-wifi_off': 'assets/core-icons/wifi_off.svg',
  'icon-working-yard-bold': 'assets/core-icons/working-yard-bold.svg',
  'icon-wrench-bold': 'assets/core-icons/wrench-bold.svg',
  'icon-zoom-out': 'assets/core-icons/zoom-out.svg',
};

export const iconsHashes: AppIcons = {
  'icon-account_circle': '34b05ec2d2fb0112f520d0c08970d20e',
  'icon-add-circle': '4553df468dc43edfe48c8cb074379566',
  'icon-add-image': 'd1c3a4e218590e3a763182c0c8d83fb8',
  'icon-add-note': '7ca85729e4428dc21969664aac3a4dfb',
  'icon-add': 'cf14898587b5bdadcaf9571b32244717',
  'icon-allow_login_access_black': '032f7a1f81abb283311ee60654f7ff26',
  'icon-archive': '32d2731eef24937768f46734dfaebd41',
  'icon-arrow-back-1': 'c27d34302a3b704f9c803a18c70b4ad6',
  'icon-arrow-back': '239ee26e524df1b55a874af46dcdda58',
  'icon-arrow-down-up': '19de31a33a56d56c87126fd88c1e0e91',
  'icon-arrow-down': 'b6d8613ba8f3f7b8be3e9552a64aa8d3',
  'icon-arrow-drop-down': '7c5a5afd9b318fa7ca74b9a437e8f17d',
  'icon-arrow-drop-up': 'df3a0d190869e9e25ec984ce80576d7f',
  'icon-arrow-forward-1': '808ef20fb3100add7ec24c27dbafc752',
  'icon-arrow-forward': '9fb102dde12651444dae616d0771b5c4',
  'icon-arrow-left': '8bdff21b4b8624425215daff15096640',
  'icon-arrow-right': '2775189b56e3a731e02f15354390df30',
  'icon-arrow-up': '874d5ff217e748e9430e47a88ec311d5',
  'icon-arrow': 'd2841d1d46084da844ce88ced29fecbc',
  'icon-arrow_fill': '07a248dd716eb2f81e0746adfe6d0ad9',
  'icon-at-sign': '699fd6c24d9994537c9bedb018586b27',
  'icon-attach': '90760e53210bfb9244240bc53a264c7b',
  'icon-automation': '232a0d0f4ca722b9545ab88a93f3da65',
  'icon-bar_chart': 'c0f9f426eee181224d2131ccde37792f',
  'icon-barcode-scan': '4a567a3692d8cb69f36bdc133fdc384a',
  'icon-battery-tracker': 'adb9b0e688e2668dad1307b0304d27c3',
  'icon-battery_alert': '9dacb92cb898fba91de387c580825fe8',
  'icon-bookmark-bold': 'feced997a1bd1a0dec049f439361f20a',
  'icon-bookmark': 'a35866cca74ffb0e2db51aa2bb4e911a',
  'icon-brick': '26ed9af8dd8f4e1f62f86078b458147c',
  'icon-business-center-bold': '0f284873f4c8c90debc11f8520076e07',
  'icon-business': '9f02ef623d5bd0c881de53a2d0c8b813',
  'icon-cabin_view': '7f2b933e62afbe6d25a024e2b55f0f2d',
  'icon-cabin_view_filled': '7f2b933e62afbe6d25a024e2b55f0f2d',
  'icon-calendar_month': '71cbc60e558a1f76f816a4daf860d28a',
  'icon-call': 'afb31cc5ec44e570800d2964728b7eb9',
  'icon-camera-1-way': 'a749ceb71e71a656ea54782cef386fa2',
  'icon-camera-2-way': 'e86bd9182077efe0056b37dd4a9a4ad3',
  'icon-camera-3-way': 'a35951b3a8174e548e6ca825332a5edc',
  'icon-camera-4-way': 'e724ac91f5da64a236d12184e6608fee',
  'icon-camera-plus': 'bcbe006fb604f7e165215406db7e5a94',
  'icon-cancel': '481dca258bd77f84c6c1d42c601e1a70',
  'icon-chat_bubble_outline': 'bdacfc9487fb64a7e790cc3f7fce27f7',
  'icon-chats-bold': '12091efd84b88281bce49c8d02c300af',
  'icon-chats-outline': '9f3c120937c71ffc7211798aec881624',
  'icon-check-circle-bold': 'f3cbf064238e0043794e807fcf806afe',
  'icon-check-circle': 'd9ad8fe4eae748e0fa6301b4580e0187',
  'icon-clipboard-tick-bold': 'e69b05fdb9d817c60c46724b2595443d',
  'icon-clipboard': 'a276295e6c078bd2ff2ddd05fb74d0f2',
  'icon-clock-bold': '1da2bbe3a62bb7f3576dba49fb9a6d17',
  'icon-clock': '4e09ebf3f181ebb3140f75717a0bbf68',
  'icon-close': '7065f3ef7fe31bcaf120460245fc45be',
  'icon-cloud-upload': 'e674b9ac3bb08ac143ab6920b6443176',
  'icon-collections': 'e78118629dab9d58f68ee3b7a337a271',
  'icon-compact-view': 'd78994958654d7c64231765ce18adb10',
  'icon-contact_phone': 'afb31cc5ec44e570800d2964728b7eb9',
  'icon-content-plus': 'c90435166b03df631e5ebe2ae4795708',
  'icon-copy-link': '49922a115b463178513829ed26cec42b',
  'icon-copy': '16fde684b63b649dd7f252221e37d176',
  'icon-crm-bold': '7835696cae8947f76c5520c0ddd2a332',
  'icon-crm-outline': '07f76a49fe0fda3eae7b6867f68ee4f0',
  'icon-crm_admin_assign': '032f7a1f81abb283311ee60654f7ff26',
  'icon-crm_admin_unassign': '3ce79f5e505d4d50a4c9d5dab7b8da1e',
  'icon-date_range': '71cbc60e558a1f76f816a4daf860d28a',
  'icon-delete': 'b5cad7642aff9d05147b624f27c35b08',
  'icon-direct-message': '3e822ee37ebac1d54bc1cc8e59bfc327',
  'icon-directions': 'dfe9aeef5d909de0868e48aeeec2614e',
  'icon-document-bold': '8339d4ca945c74db296b76b3cbdc8be5',
  'icon-document-outline': '4da49ea82989e426cfb79420af13ab77',
  'icon-download': '8f828cc3882f72b96114cd35b2e8ff82',
  'icon-drag-indicator': '419b57bccd0f93a2d1d1c285b9a0fa76',
  'icon-draw-boundary': '0ddf9e9bb37b47c0ee4c25ca8525405b',
  'icon-draw-circle': '78d26559ea30e37edf05295714e4ab5b',
  'icon-draw-polygon': '163121a78f94be0105b7c0b789e8820b',
  'icon-drop': '42d2d0d631cdef24727c9bbfb03eac99',
  'icon-dvr-camera': '16dc29209e9da27e450fd7aab4063271',
  'icon-edit': 'ed25d843f423d89018c029e28c43937d',
  'icon-emoji': 'aa493edade7d07816b51daed5e731507',
  'icon-empty_state_alert': '62faf9c7ba16673b4ec59179283c09ab',
  'icon-empty_state_clock-stopwatch': 'dd3b03609172cd42bcac0163aa343bc7',
  'icon-empty_state_documents': 'cb387eeaf3f11466f0f11562722f227f',
  'icon-empty_state_employee_group': '8b1b6be9c8f40ec605b6034151090681',
  'icon-empty_state_event': 'e7f3ae4d0e2b3cd0caf69e56b5dc8d63',
  'icon-empty_state_history': 'a3c253103ed62adf69ed563f42afa939',
  'icon-empty_state_media': 'b7ba5f1e31e30da452fcf59bb142f444',
  'icon-empty_state_message-chat': '33c8a75810a9d67d0296f4f9635b89be',
  'icon-empty_state_mobile-x': '80ada957b205c3e4358681b9cd9c88ca',
  'icon-empty_state_no_access': 'e8f92e5e6e1a7eb4206df07cd6dce733',
  'icon-empty_state_vehicle': '634bc2e84a43e465e90263af65bbe771',
  'icon-engine-bold': 'be78d9a955d4a8fed589a6aca90424a2',
  'icon-engine-hours': '3501e633031540256c38084633493505',
  'icon-engine': 'a9e52285eee96d295bda6afebb074d7e',
  'icon-enter': '9b9654c3967f99047f28a58e42388665',
  'icon-entered': '0993124e8fd73c26d9875c8ef7d3deae',
  'icon-error': '19e840385079e105fb939a422909ebb6',
  'icon-ev-station-bold': '702c72d613e9e9e0ad5ebb43ebfa7d30',
  'icon-events-bold': '463d655f24db569dc50f9b9aa0ccc7ed',
  'icon-events-outline': 'b2fbc46b06ae5ba561802e31e17ddd0c',
  'icon-fiber_pin': '7a3b53b36c9f0ee0c17c63c747396168',
  'icon-file': '81f1cc3043de6f5e885821b58d8d58d4',
  'icon-filter': 'eb1f700235239f5d419d5aaf0443314d',
  'icon-first-page': '8e5464014485530f7b833acc6ac4eda0',
  'icon-flag-bold': '52a57a60a9a29e7f632f582a83349a29',
  'icon-flag': '9d6ca4d99f9bee1aa29f3530fa51ecfd',
  'icon-flame-bold': '9962342450eb45f223fd1d79a246cd8e',
  'icon-flash-bold': '308bbd0453409d1a5c57352ecf5e88db',
  'icon-folder': 'e7e29729fd228f8f948480ebc44cb110',
  'icon-format-bold': 'cdb0da469446c4633047d93649d37af9',
  'icon-format-clear': '571e706730f0e4850bce85852ddc251b',
  'icon-format-italic': '931dca3244ca8fcc96ac11e53e11a87f',
  'icon-format-underlined': '41a826030b294a614687ea1178423126',
  'icon-gas-station-bold': 'd9aae84385c8b6866e06522eb9b991e2',
  'icon-gps-slash': 'e911fe35bfcf9c5ce7a2b1a3ef97ebd2',
  'icon-grain': 'a853b18d904981161db7489c97bf81da',
  'icon-grid-2': '875465db28205bbbbaea44bf9c034ee6',
  'icon-grid-3': 'ce8c3719d390b035e32a3eb275afb91c',
  'icon-grid-4': '32db3c553db90c471dc26c4f99921bc3',
  'icon-grid': '064e703dfa3a6914c08fa8dee7f54128',
  'icon-group-bold': 'b209e7e49b1377f49b0624ee06f1521a',
  'icon-group-outline': 'd2500c784fd645880fd2ddb781b8d5d9',
  'icon-hardware': 'c0f872367599a974276db2b8c98f8de3',
  'icon-hardwired-tracker': '86b381e34e6403a3d6e2293ffeab2417',
  'icon-hashtag': '88763a5475f901fbff60d572c58f3828',
  'icon-heart-bold': 'f362e3bdfcaedbd727218ed02408345a',
  'icon-help-bold': 'f13f72d78661bd7049ca6f2403a829b6',
  'icon-help-outline': 'f53c8434a9ba4b7e69fb2b44d5727394',
  'icon-highlight_off': '8f736acdfd5eed76e70e2c0ec8356d6d',
  'icon-home-bold': 'f84ae90d3d5535da52d316eefd0ed9dd',
  'icon-home-outline': 'ee2efc7ee5bc99cbe4b3bcc55e11584e',
  'icon-hotel-bold': '0b4af0d111966065a48ae02da7a11849',
  'icon-image-slash': '8c2f543f0041de4ce10752986141ae06',
  'icon-image': 'e6294d9af24ac5d506f6fbf8524a4aa0',
  'icon-in-progress-status': '1df30cb6add87a71f82006a3903a8e6c',
  'icon-inbox': '84fa588f500ef0ad528fbce0cc6cad01',
  'icon-info-circle': 'cc8c579c2e26e86dd424f7235cf12fd4',
  'icon-info_filled': '29b2c48800073605c80510873730f081',
  'icon-inspections-bold': '7a350b7f8588c4eed0e6407d436036d2',
  'icon-inspections-outline': 'eb9cd6e78dc56b4ace6cdca70a555f47',
  'icon-inventory': '281e643d64e83e31b65f4c095652d6e6',
  'icon-kanban': '31f88c79a885e0429f3a6ba3140f3fd9',
  'icon-key': '60b7ec66733101786b4c46513e4110df',
  'icon-lamp': 'bc08d530c6151c052a32ac4aa7e5e3a7',
  'icon-landscape-bold': 'ea8ccf8d4be05dc309181cb651a726a9',
  'icon-landslide': 'b511aca71a3ba12ee610429b9852573e',
  'icon-last-page': '3ac5ddf6befd94506eb625ef63bd2faa',
  'icon-layers': 'f35badfefd17ae418d3b7469b1aa5d40',
  'icon-leaf': '72cc2b3e6324e596e0232454a4e71b2c',
  'icon-link': 'cf12866481ee0c617b38775c9559fa05',
  'icon-list-bulleted': '01332cd9d56c048aa3215913e2404c08',
  'icon-list-numbered': '1e63a3904eafa9df27509bbba9369d3c',
  'icon-load': 'c82397154374cec51c84e777c79b9228',
  'icon-local_shipping': '0f844b2da955593ae9f35666a4e37c79',
  'icon-location-bold': '55944a3f8bd488c327183a09d1e5d3e9',
  'icon-location-outline': 'a5491dcac94c6cf83fddb70745d04cb4',
  'icon-lock': '1593e3920b16a615216f741b2248273d',
  'icon-login': '71633c4bb8bfde61b89ab86f9081f1d1',
  'icon-logout': '2a064a62794c71339f7968e3b8e63e88',
  'icon-mail': '59c08c1df688f971b58c890f3a53d6c9',
  'icon-mail_outline': '59c08c1df688f971b58c890f3a53d6c9',
  'icon-main-image': '9a82bedac5b1e134b9d8da5a5c0a2926',
  'icon-map-bold': 'e8dee674fa668f9a1caa0dd1798c02d0',
  'icon-map-outline': '2d9d5458deb5e553277d25d1db31ef85',
  'icon-marker-arrow': '09e5c394527c2afb0929f57d6e01aeec',
  'icon-max-hours': '6552758d1fd76b45c97c0edbe418bdf0',
  'icon-maximize': '9ef74250e8c9723185c61ee543edc97c',
  'icon-mdi_clock-remove-outline': '16fce3640cd3777593934267c6fed1fe',
  'icon-menu': '185beebcdd2217ac453e88e33db95e51',
  'icon-microphone': 'de06f214c07cac07f33343c44dc62592',
  'icon-miles': '230b656cbdcfbc8e47dacc8083a808fe',
  'icon-min-hours': '9812461dd146f6c277c3252fd2812cfc',
  'icon-minimize': 'f847932517b9737087951a397832af38',
  'icon-minus-circle-bold': '2dd2e0b1593be92a2b35dd79fa27416f',
  'icon-moneys': '39123dc5c52a3e4505dd014dbb9feed5',
  'icon-monitor-mobile': '69bef63a62709ed5566e418a81121022',
  'icon-more': 'c5ebf795acccb9ffa8926e7ffe83856a',
  'icon-my-location': '3c83d8dd1a0711132225f22302c867f8',
  'icon-new-window': '1a7f687d5362cbee6d9e519d168f493c',
  'icon-news-bold': 'da7411bb84d9aae7bec90e2f9a7e9818',
  'icon-news-outline': '7188fb5f50b3f9ae5dc8262581c906fb',
  'icon-no-date': '4d23a2241a81ae180ce094bea156cd09',
  'icon-none-qr': 'a140ed55b707e86320c93a79a88286d4',
  'icon-notes': '7fa3e6b706e01882f61c99001a65fac5',
  'icon-notification-bold': 'a2189ec277a99615754a10e461371872',
  'icon-notification-outline': '919926ba34531e4dc4c511d165667249',
  'icon-notifications-off': 'bd87419e7c4a581b0922a6d55ba90b72',
  'icon-operator-off': 'da8b59cd0479a3be0a1e7ce682a75cb7',
  'icon-operator-on': 'a050e9993cb06a8ad1949b8d12f2e083',
  'icon-operator': '0f844b2da955593ae9f35666a4e37c79',
  'icon-operator_off': 'da8b59cd0479a3be0a1e7ce682a75cb7',
  'icon-operator_on': 'a050e9993cb06a8ad1949b8d12f2e083',
  'icon-pan-tool': '2007cdbb76000835a4bebe372fed6e55',
  'icon-parking-bold': '1b7591538c7095225e7a24b4943b29a3',
  'icon-pause-bold': '5e6367fd039435fd3844594c457eed19',
  'icon-pause': '5329f487c06ffe9cccad7f4ab2334aae',
  'icon-perimeter': '62e7ee0f000bb344e3a3aae8f529ec94',
  'icon-person': '7f2b933e62afbe6d25a024e2b55f0f2d',
  'icon-pick-up': 'bf11ccade05e0d92d1673664585288e0',
  'icon-picture-in-picture': 'b8c944425e018b38984efa88e2e70ec0',
  'icon-pin': '5df4040521c5b1c87a8f74d01e0634ba',
  'icon-play-bold': 'dcec10c865f98476bfac3ba913753e2f',
  'icon-play': '3520ece3c3e8e16e1a60c4d56ef7ed8d',
  'icon-poll': 'c0f9f426eee181224d2131ccde37792f',
  'icon-power': '7fe6af26413841796711219875e558ae',
  'icon-profile-circle': '34b05ec2d2fb0112f520d0c08970d20e',
  'icon-project': '2b1350cbe4e5bab7486cb29849358fa2',
  'icon-public': '4bdae2f3d86ff219055e476627bd153f',
  'icon-qr-scan': 'e27f0ba6b397d4aef11d8895729a4a04',
  'icon-radio-button-off': '1b0bfec174dee845ca06ebf09c63e670',
  'icon-radio-button-on': '9fbce936d683e79005d72e587a40beda',
  'icon-record-stop': '277a9bbcb85e10c36849a6a7395acf02',
  'icon-record': '575721b5af897744fccc7fd3775abc55',
  'icon-recycling': '8cbdce1ae8a90fb6ac218bce7fa654de',
  'icon-redo': '3152d1e536a8b504e5e66a081c68d2b2',
  'icon-refresh': 'ab5273ba88d3abe374a84774edb4a385',
  'icon-reload': '23c0c9821493688ab339e8d15d6cc231',
  'icon-remove': '82d45f7cc628dd29e936dc450465dd48',
  'icon-reply': '6765fed88f9db5b2c3e266c56cd2e45e',
  'icon-reports-bold': 'f6e07d4540faf97fa7666ee297e38397',
  'icon-reports-outline': 'c39b885f9543bbcfb511333d19ae4e24',
  'icon-restaurant-bold': '53f93fe62763396cb33b3e6c24722c2a',
  'icon-restore': 'a6057ae0db06b248d018ba3cab3a82c9',
  'icon-road': 'c3059bbf990c3f7f6a24c98520ae0798',
  'icon-route': '230b656cbdcfbc8e47dacc8083a808fe',
  'icon-route_map': '230b656cbdcfbc8e47dacc8083a808fe',
  'icon-save': 'd1f7ed31c9cc91cd013c2d73bd6c0e2e',
  'icon-scroll': '9b2f85d8ff63b15b3bc2ae7e71540eea',
  'icon-search-bold': '89313a3a9411d5e9d59cf2826498d025',
  'icon-search-outline': '7633a18b24f284029ec5e71f189f1113',
  'icon-search-zoom-in': 'eac38dcb9bf4effed55e852a62db070b',
  'icon-search-zoom-out': 'e58114afd36dccffda027035381b50a6',
  'icon-send-bold': 'ca26d34807bf593a80789a119301a960',
  'icon-settings-bold': 'c7e2bde5926c304cfb34c329377a3527',
  'icon-settings-outline': '72ad346b18e125b38417db5e7bde97c6',
  'icon-share': 'ce3cf93daf1900b3d5240f98cd0c023b',
  'icon-shield-tick-bold': '94cc90797a6169a59cb144c83e712eb3',
  'icon-sidebar-left-outline': '73afbf128053496cb261f054d614fffe',
  'icon-sidebar-right-outline': '48ead4193014017251ffeaf2e5591b27',
  'icon-signal': '33686b36de324c4cbb17338e9c09d53b',
  'icon-simple': '5f1bb3278c54bdbd53532517473e7570',
  'icon-slash': 'c47399fe15e2c0aaafbe27b4d7f8e049',
  'icon-solar-tracker': '00d88068752f3592f793c4736418f357',
  'icon-sort': '876429de297095deb8d268b4e4a4df9d',
  'icon-speed': '0085940fd6558bb61815b532186fb74c',
  'icon-star-bold': 'c85ca33565570e830b9b7a1a0529df34',
  'icon-star': 'b28bcdfd5aa7bccc46e24a4693be1414',
  'icon-status-idling-bold': '9122dd51f6d53bdc6c32225c77a3120e',
  'icon-status-stopped-bold': 'ea70fb7d939570ab53cfccfd4370e43f',
  'icon-status-towed-bold': '8a7194bbdda339511ede879cb1bb677c',
  'icon-status-traveling-bold': 'cc41b2e5569e544580481f941fe33651',
  'icon-status': '8550bc3c96ef01836242d41047026da0',
  'icon-subdirectory-arrow': 'd79a2e12bf768242be1099c170f5546f',
  'icon-swap-bold': 'fbdca71b50f9d405491e1d19a4146a5c',
  'icon-swap-calls': '9b516ae286cce634ced1da68a657b548',
  'icon-swap-outline': 'e267344b489df90be10e73552b4734a7',
  'icon-table': '8854ae7f81c28cdebf7b13ff2cddf64a',
  'icon-tablet': '399c73edbd33bc86ff2f5f21409f9c55',
  'icon-tasks-bold': 'cd9b375416d5850f6becd867df09df60',
  'icon-tasks-outline': '2cc610574da19f05d6c0a4709e034e13',
  'icon-text-format': '71f9bf963c2c607f464bc53ecfc533b5',
  'icon-texture': '8ec110f77c3ffc0c5c7313b43f97766d',
  'icon-tick': 'c0e57ca565a77b6255a0cf9be19ea702',
  'icon-today': '71cbc60e558a1f76f816a4daf860d28a',
  'icon-tool-bold': '37ff48bc286ba283adc55abe80d86158',
  'icon-tool': '189c8945de8ed3cba084ebfe9625c879',
  'icon-tree': '46a4af08b4bc5f3f444e7a9d3896a89d',
  'icon-unarchive': '483da366f11181ef10fffbc93b3f31a4',
  'icon-undo': 'd40464813e08ab28754268b1a5780724',
  'icon-unlink': 'c2a5ee38050339fef039f5023e641731',
  'icon-unpin': 'b5e1419101d5f995c3f2b959858755dd',
  'icon-upload': 'af6221bf386eef080af89f351682bb93',
  'icon-user-group': 'e9821a7b12e7cdc401223b8de1f587c6',
  'icon-user-remove': '3ce79f5e505d4d50a4c9d5dab7b8da1e',
  'icon-user-tick': '032f7a1f81abb283311ee60654f7ff26',
  'icon-user': '7f2b933e62afbe6d25a024e2b55f0f2d',
  'icon-vehicles-bold': '6e6ffd95cf7cd1f05b36a7a43dc1e494',
  'icon-vehicles-group': '4814bd68ec2bb35b82c64e67b6f49ba2',
  'icon-vehicles-outline': '0f844b2da955593ae9f35666a4e37c79',
  'icon-video-request': '4c57e9aa79b4ab7f0b15af725bd5b099',
  'icon-videocam': '63028ccef24e72f20aa97f841ebb2939',
  'icon-visibility-off': '82ab5c4165eaa703f7907bc3ff1e051b',
  'icon-visibility': '86be15b84e8f0549f8d181df7e02ddb4',
  'icon-volume-off': '8b3bfc5daf9c023b278d6796fd8b85b4',
  'icon-volume-up': 'd793c17f5b7321017f7d0ca68badf86d',
  'icon-warning-bold': 'e9205d91be8b3cbab1ad6571b8bfdf0b',
  'icon-warning': '4816248485de1209e8a1f91fb731b076',
  'icon-water': 'a46077d735bab42adf34fbba3938d866',
  'icon-wheel': '13b3bc95a5712673e060381a25d410ef',
  'icon-wifi': '219289fee9b88b785d469585ce3354ad',
  'icon-wifi_off': '6d82cef9639007ba8bf2d2ab2719ad12',
  'icon-working-yard-bold': 'ba5c7db5d1cdebba525cb2fa96ef8ecb',
  'icon-wrench-bold': 'ebed94db0e1bd27c15bda26facf66919',
  'icon-zoom-out': '409de19fbb8e9d50947d22f5163313cd',
};
